module.exports = __webpack_public_path__ + "static/videos/litho_006.cbcdbaa.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/litho/litho_006.mp4
// module id = 475
// module chunks = 1